import React from 'react';
import { Router } from '@reach/router';
import { Notifications } from '../../screens';

const AppRouter = () => (
  <Router>
    <Notifications path="/" />
  </Router>
);

export default AppRouter;
